const UNSUPPORTED_QUOTATION_MARKS = [`'`, `"`];

export default function sanitizeClosingQuotationMark(quotationInput: string) {
  let sanitizedInput;
  const isUnsupported = UNSUPPORTED_QUOTATION_MARKS.find((unsupportedQuotationMark) => {
    return quotationInput.includes(unsupportedQuotationMark);
  });
  if (isUnsupported) {
    sanitizedInput = `'"'`;
  } else {
    sanitizedInput = `'${quotationInput}'`;
  }
  return sanitizedInput;
}
